import { useState, useCallback, useMemo } from 'react';
import { PRINTED_NAME_MAX_LENGTH } from '../constants';
import { validatePrintedName } from '../utils';
import type { SignatureCaptureState } from '../types';

type UseAcknowledgmentStateResult = {
  printedName: string;
  setPrintedName: (name: string) => void;
  isValid: boolean;
  resetForm: () => void;
};

export const useAcknowledgmentState = (
  signatureState: SignatureCaptureState
): UseAcknowledgmentStateResult => {
  const [printedName, setPrintedNameInternal] = useState('');

  const setPrintedName = useCallback((name: string) => {
    if (name.length <= PRINTED_NAME_MAX_LENGTH) {
      setPrintedNameInternal(name);
    }
  }, []);

  const isNameValid = useMemo(
    () => validatePrintedName(printedName),
    [printedName]
  );

  const isValid = useMemo(
    () => isNameValid && signatureState.isConfirmed && !!signatureState.dataUrl,
    [isNameValid, signatureState.isConfirmed, signatureState.dataUrl]
  );

  const resetForm = useCallback(() => {
    setPrintedNameInternal('');
  }, []);

  return {
    printedName,
    setPrintedName,
    isValid,
    resetForm
  };
};
